(function () {
  const panels = ['user-panel', 'cart-panel'];

  panels.forEach((id) => {
    const wrapper = document.getElementById(id);
    if (!wrapper) return;

    const panel = wrapper.querySelector('[data-off-canvas-panel]');
    const toggles = document.querySelectorAll('[data-off-canvas-toggle="' + id + '"]');
    const closes = wrapper.querySelectorAll('[data-off-canvas-close]');
    
    // Flag um doppelte Klicks zu verhindern
    let isAnimating = false;

    function open() {
      if (isAnimating) return;
      isAnimating = true;
      
      // Zeige den Wrapper
      wrapper.classList.remove('hidden');
      
      // Warte einen Frame, dann slide das Panel rein
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.classList.remove('translate-x-full');
          panel.classList.add('translate-x-0');
          
          // Animation fertig nach 300ms
          setTimeout(() => {
            isAnimating = false;
          }, 300);
        });
      });
      
      // Verhindere Body-Scroll wenn Panel offen
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (isAnimating) return;
      isAnimating = true;
      
      // Slide das Panel raus
      panel.classList.remove('translate-x-0');
      panel.classList.add('translate-x-full');
      
      // Erlaube Body-Scroll wieder
      document.body.style.overflow = '';
      
      // Verstecke den Wrapper nach der Animation (mit Timeout als Fallback)
      setTimeout(() => {
        wrapper.classList.add('hidden');
        isAnimating = false;
      }, 310); // Etwas länger als die CSS-Transition (300ms)
    }

    // Event Listeners für Toggle-Buttons
    toggles.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        open();
      });
    });
    
    // Event Listeners für Close-Buttons und Overlay
    closes.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        close();
      });
    });
    
    // ESC-Taste zum Schließen
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !wrapper.classList.contains('hidden')) {
        close();
      }
    });
  });

  // Globale Funktion zum Öffnen von Panels
  window.openOffCanvas = function (targetId) {
    const targetWrapper = document.getElementById(targetId);
    if (!targetWrapper) return;
    
    const targetPanel = targetWrapper.querySelector('[data-off-canvas-panel]');
    if (!targetPanel) return;
    
    // Zeige den Wrapper
    targetWrapper.classList.remove('hidden');
    
    // Warte einen Frame, dann slide das Panel rein
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        targetPanel.classList.remove('translate-x-full');
        targetPanel.classList.add('translate-x-0');
      });
    });
    
    // Verhindere Body-Scroll
    document.body.style.overflow = 'hidden';
  };
  
  // Globale Funktion zum Schließen von Panels
  window.closeOffCanvas = function (targetId) {
    const targetWrapper = document.getElementById(targetId);
    if (!targetWrapper) return;
    
    const targetPanel = targetWrapper.querySelector('[data-off-canvas-panel]');
    if (!targetPanel) return;
    
    // Slide das Panel raus
    targetPanel.classList.remove('translate-x-0');
    targetPanel.classList.add('translate-x-full');
    
    // Erlaube Body-Scroll wieder
    document.body.style.overflow = '';
    
    // Verstecke den Wrapper nach der Animation
    setTimeout(() => {
      targetWrapper.classList.add('hidden');
    }, 310);
  };
})();

// Cart Funktionalität
document.addEventListener('DOMContentLoaded', function () {
  const cartContent = document.querySelector('#cart-content');

  if (!cartContent) return;

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#cart-content')) return;

    const minusBtn = e.target.closest('[data-cart-qty-minus]');
    if (minusBtn) {
      const key = minusBtn.getAttribute('data-cart-qty-minus');
      updateCartQuantity(key, -1);
    }

    const plusBtn = e.target.closest('[data-cart-qty-plus]');
    if (plusBtn) {
      const key = plusBtn.getAttribute('data-cart-qty-plus');
      updateCartQuantity(key, 1);
    }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      const key = removeBtn.getAttribute('data-cart-remove');
      removeCartItem(key);
    }
  });

  async function updateCartQuantity(lineIndex, change, absolute = false) {
    try {
      const currentCartContent = document.querySelector('#cart-content');
      if (!currentCartContent) return;

      const currentItem = currentCartContent.querySelector(`[data-cart-qty-input="${lineIndex}"]`);
      if (!currentItem) return;

      showLoadingIndicator(lineIndex);

      const currentQty = parseInt(currentItem.value);

      let newQty;
      if (absolute) {
        newQty = change;
      } else {
        newQty = currentQty + change;
      }

      if (newQty < 1) {
        newQty = 1;
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: parseInt(lineIndex),
          quantity: newQty,
        }),
      });

      if (response.ok) {
        await refreshCartContent();
      }
    } catch (error) {
      hideLoadingIndicator(lineIndex);
    }
  }

  async function removeCartItem(lineIndex) {
    try {
      showLoadingIndicator(lineIndex);

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: parseInt(lineIndex),
          quantity: 0,
        }),
      });

      if (response.ok) {
        await refreshCartContent();
      }
    } catch (error) {
      hideLoadingIndicator(lineIndex);
    }
  }

  function showLoadingIndicator(lineIndex) {
    const spinner = document.querySelector(`[data-cart-loading="${lineIndex}"]`);
    if (spinner) {
      spinner.classList.remove('hidden');
    }
  }

  function hideLoadingIndicator(lineIndex) {
    const spinner = document.querySelector(`[data-cart-loading="${lineIndex}"]`);
    if (spinner) {
      spinner.classList.add('hidden');
    }
  }

  async function refreshCartContent() {
    try {
      const response = await fetch(window.location.href);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartContent = doc.querySelector('#cart-content');
      const currentCartContent = document.querySelector('#cart-content');

      if (newCartContent && currentCartContent) {
        currentCartContent.innerHTML = newCartContent.innerHTML;

        updateCartBadge();
      }
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
    }
  }

  async function updateCartBadge() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = cartData.item_count;
        if (cartData.item_count > 0) {
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      });
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Cart-Badges:', error);
    }
  }

  window.refreshCartContent = refreshCartContent;
  window.updateCartBadge = updateCartBadge;
});
